import { useSelector } from "react-redux";

import { IStore } from "../interfaces/IStore";
import { IOrdersState } from "@/redux/interfaces/IOrders";

export const getOrders = (state: IStore): IOrdersState => state.orders;

export const useTradeOrders = (): IOrdersState => useSelector(getOrders);
